import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";

export default function WarningReviewLimitedDialog({ open, limit, onClose }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <Typography fontWeight={"bold"} fontSize={"1.1rem"}>
                    محدودیت در ثبت درخواست بازبینی
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Typography>
                    شما از {limit} دفعه مجاز برای ثبت درخواست بازبینی و حذف
                    جریمه استفاده کرده‌اید. تا چله بعد، امکان ثبت علت جدید و حذف
                    جریمه وجود ندارد.
                </Typography>
            </DialogContent>

            <DialogActions>
                <Container>
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={onClose}
                        size="large"
                        sx={{ fontWeight: "bold" }}
                    >
                        متوجه شدم
                    </Button>
                    <Box sx={{ height: "8px" }} />
                </Container>
            </DialogActions>
        </Dialog>
    );
}
